import { UntypedFormGroup, UntypedFormControl  } from '@angular/forms';
import { Product } from '@app/_models/orders/shared';

export function buildAddOnForm(products: Product[], existingIds: number[], formGroup: UntypedFormGroup ) : void {
    products.forEach(product => {
        var exists = existingIds.find(x => x === product.id) != null;
        var id = product.id.toString();
        formGroup.addControl(id, new UntypedFormControl(exists));
      })
}

export function hasAddOnProducts(formGroup: UntypedFormGroup, productId: number, checked: boolean) : boolean {
    return checked ? true : getSelectedProductIDs(formGroup).filter(x => x != productId).length > 0;
}

export function getSelectedProductIDs(formGroup: UntypedFormGroup) : number[] {
    return getSelectedProductKeys(formGroup).map(x => parseInt(x));
}

function getSelectedProductKeys(formGroup: UntypedFormGroup) : string[] {
    return Object.keys(formGroup.controls).filter(x => formGroup.controls[x].value === true);
}
